export default {
  setIdPrestador: (state, _id) => (state.idRnpPrestador = _id),
  setFetched: (state, _boo) => (state.isFetched = _boo),
  payloadServidor: (state, _payload) => (state.payloadServidor = _payload),
  setTipoQuestionario: (state, _tipo) => (state.tipoQuestionario = _tipo),
  setPullComplexidades: (state, _boo) => (state.pullComplexidades = _boo),
  setComboComplexidades: (state, _payload) =>
    (state.comboComplexidades = _payload),
  setPayloadComplexidades: (state, _payload) =>
    (state.payloadComplexidades = _payload),
  limparStore: state => {
    state.idRnpPrestador = null;
    state.isFetched = false;
    state.pullComplexidades = false;
    state.payloadComplexidades = [];
    state.comboComplexidades = [];
    state.tipoQuestionario = "";
    state.payloadServidor = {};
    state.payloadCliente = {};
  }
};
